import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { AmendmentListProvider } from './context/amendment-list-context';
import { AmendmentListComponent } from './amendment-list-component';

export function AmendmentListFactory() {
    return (
        <BaseLayoutFactory>
            <AmendmentListProvider>
                <AmendmentListComponent />
            </AmendmentListProvider>
        </BaseLayoutFactory>
    );
}
